import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        debug: false,
        fallbackLng: 'fr',
        interpolation: {
            escapeValue: false // not needed for react as it escapes by default
        },
        resources: {
            en: {
                translation: {
                    "schedules": "Schedules",
                    "loading": "Retrieving schedules...",
                    "monday": "Monday :",
                    "tuesday": "Tuesday :",
                    "wednesday": "Wednesday :",
                    "thursday": "Thursday :",
                    "friday": "Friday :",
                    "saturday": "Saturday :",
                    "sunday": "Sunday :",
                    "closed": "Closed",
                    "exceptionally closed": "Exceptionally closed",
                    "exceptionally": "(Exceptionally)",
                    "error": "Schedules are currently unavailable."
                }
            },
            fr: {
                translation: {
                    "schedules": "Horaires",
                    "loading": "Récupération des horaires...",
                    "monday": "Lundi :",
                    "tuesday": "Mardi :",
                    "wednesday": "Mercredi :",
                    "thursday": "Jeudi :",
                    "friday": "Vendredi :",
                    "saturday": "Samedi :",
                    "sunday": "Dimanche :",
                    "closed": "Fermé",
                    "exceptionally closed": "Fermé exceptionnellement",
                    "exceptionally": "(Exceptionnellement)",
                    "error": "Les horaires sont actuellement indisponibles."
                }
            }
        }
    });

export default i18n;
